import { getPropertyValue } from "../../common/util/changeUtils.jsx";

/**
 * Returns the estimated value of the tobacco return
 * @param {object} tobacco 
 * @returns {number}
 */
export function estimatedTobaccoReturnValue(tobacco) {
    let value = 0.0;
    for(let i=0; i<tobacco.bagSupplier.length; i++){
        const supplier = tobacco.bagSupplier[i];
        for(let j=0; j<supplier.bags.length; j++){
            const bag = supplier.bags[j];
            for(let k=0; k<bag.lines.length; k++){
                const {product, wishedQtySalesUnits} = bag.lines[k];
                value += (product.pricePerSalesUnit) * wishedQtySalesUnits;
            }
        }
    }
    return value;
}
/**
 * Returns empty string if all bags has validated bagnumbers, otherwise 
 * @param {object} tobacco 
 * @returns {object}
 */
export function isAllBagNumberValidated(tobacco) {
    for(let i=0; i<tobacco.bagSupplier.length; i++){
        const supplier = tobacco.bagSupplier[i];
        for(let j=0; j<supplier.bags.length; j++){
            if( supplier.bags[j].bagNumberValidated===false){
                return { supplierName: supplier.supplierName, supplierId: supplier.supplierId, bagId: j};
            }
        }
    }
    return null;
}

/**
 * Returns the number of lines in the return
 * @param {object} tobacco 
 * @returns {number}
 */
export function getTobaccoReturnLineCount(tobacco) {
    let value = 0;
    for(let i=0; i<tobacco.bagSupplier.length; i++){
        const supplier = tobacco.bagSupplier[i];
        for(let j=0; j<supplier.bags.length; j++){
            value += supplier.bags[j].lines && supplier.bags[j].lines.length || 0;
        }
    }
    return value;
}

/**
 * Returns how many of a specific product that is added to current claim
 * @param {object} activeObj 
 * @param {string} productId
 * @returns {func}
 */
export function countAddedSalesUnits(activeObj, productId){
    let count = null;
    const lines = getPropertyValue(activeObj,"lines");
    if( lines ) {
        for(let i=0; i<lines.length; i++) {
            if( lines[i].product.productId === productId ) {
                count = lines[i].claimQtySalesUnits || 0;
            }
        }
    }
    return count || 0;
}

/**
 * Returns how many of a specific product that is added to current claim
 * @param {object} activeObj 
 * @param {string} productId
 * @returns {func}
 */
export function countAddedWarehouseUnits(activeObj, productId){
    let count = null;
    const lines = getPropertyValue(activeObj,"lines");
    if( lines ) {
        for(let i=0; i<lines.length; i++) {
            if( lines[i].product.productId === productId ) {
                count = lines[i].claimQtyWarehouseUnits;
            }
        }
    }
    return count || 0;
}